import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/whatsapp.svg',
})
export class WhatsappComponent {}
